// Generated by ts-to-zod
import { z } from 'zod';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const organizationGroupOrganizationListQuerySchema = paginationQuerySchema;
